import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  li {
    word-break: inherit;
  }
`;

export const AddressAndContactInfo: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <p>
        You need to ensure that you select the most specific address/location. Or if entering a manual address make it
        as detailed as possible otherwise this could delay your order. In addition, if you are entering the address
        manually, it would be helpful if you could add site coordinates.
      </p>
    </Container>
  );
};

export const SiteConfigInfo: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  return (
    <Container>
      <h4>Provide specific location details?</h4>
      <p>
        This information should be as specific as possible, otherwise this could delay your order while Neos Networks
        validate your requirements.
      </p>

      <h4>Connector type</h4>
      <p>For 1Gbps and 10Gbps ports only:</p>
      <ul>
        <li>LC = fibre optic connector type (small form factor fibre).</li>
        <li>SC = fibre optic connector type (large form factor fibre).</li>
      </ul>

      <h4>Media type</h4>
      <ul>
        <li>LX = Single Mode.</li>
        <li>SX = Multi Mode.</li>
      </ul>

      <h4>Power supply?</h4>
      <ul>
        <li>AC power is typically distributed at the local mains voltage of 120&nbsp;V, 208&nbsp;V, or 230&nbsp;V.</li>
        <li>DC power is typically distributed at the telecommunications standard voltage of 48&nbsp;V.</li>
      </ul>

      <h4>Auto Negotiation</h4>
      <p>
        Auto Negotiation is a signalling mechanism and procedure used by Ethernet by which two connected devices choose
        common transmission parameters, such as speed, duplex mode, and flow control.
      </p>

      <h4>VLAN tagging (Ethernet Point 2NNI only)</h4>
      <ul>
        <li>A-end: configured as VLAN Based as standard. NNI VLAN reference is mandatory.</li>
        <li>
          B-end: configured as Port Based as standard. Select VLAN tagging at B-end if VLAN Based configuration is
          required at <span className="text-nowrap">B-end</span> in addition to the
          <span className="text-nowrap"> A-end</span> NNI VLAN Ref.
        </li>
      </ul>
    </Container>
  );
};
